import { Accordion, AccordionDetails, AccordionSummary } from '@/features/uiKit/Accordion';
import { Text } from '@/features/uiKit/Text';
import { ExpandMoreIcon } from '@/features/uiKit/icons';
import React from 'react';

export interface FaqItemInfo {
  question: string;
  /** Wrap text answers in `CardDescription` so they pair with the question. */
  answer: React.ReactNode;
}
export const FaqItem = ({ info }: { info: FaqItemInfo }) => {
  const { question, answer } = info;
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ padding: '0' }}>
        <Text as="span">{question}</Text>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          padding: '0 0 30px 0',
        }}
      >
        {answer}
      </AccordionDetails>
    </Accordion>
  );
};
